/**
 * SIGGO — puntos del carrusel de servicios del footer (solo movil).
 *
 * El deslizamiento NO lo hace este script: es `scroll-snap` nativo en CSS
 * (`sections/siggo-servicios.liquid`). Aqui solo se hace esto:
 *   - marcar el punto del bloque que esta a la vista;
 *   - al pulsar un punto, llevar el scroller a ese bloque.
 *
 * En escritorio los puntos estan en `display: none` y el scroller no
 * desplaza, asi que todo esto queda inerte sin tener que comprobar el ancho.
 */
(() => {
  class Servicios {
    constructor(raiz) {
      this.pista = raiz.querySelector('[data-siggo-serv-track]');
      this.puntos = Array.from(raiz.querySelectorAll('[data-siggo-serv-dot]'));
      if (!this.pista || !this.puntos.length) return;

      let pendiente = false;
      this.pista.addEventListener(
        'scroll',
        () => {
          if (pendiente) return;
          pendiente = true;
          requestAnimationFrame(() => {
            pendiente = false;
            this.sync();
          });
        },
        { passive: true }
      );

      this.puntos.forEach((p, i) => p.addEventListener('click', () => this.ir(i)));
      window.addEventListener('resize', () => this.sync(), { passive: true });
      this.sync();
    }

    /** Cada bloque mide lo mismo que la pista (`flex: 0 0 100%`, sin hueco). */
    get actual() {
      const w = this.pista.clientWidth;
      if (!w) return 0;
      const i = Math.round(this.pista.scrollLeft / w);
      return Math.min(Math.max(i, 0), this.puntos.length - 1);
    }

    ir(i) {
      this.pista.scrollTo({ left: i * this.pista.clientWidth, behavior: 'smooth' });
    }

    sync() {
      const a = this.actual;
      this.puntos.forEach((p, i) => {
        if (i === a) p.setAttribute('aria-current', 'true');
        else p.removeAttribute('aria-current');
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-siggo-serv]').forEach((raiz) => {
      if (raiz.dataset.siggoServListo) return;
      raiz.dataset.siggoServListo = '1';
      new Servicios(raiz);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // El editor de temas vuelve a pintar la seccion al cambiar ajustes.
  document.addEventListener('shopify:section:load', init);
})();
